import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=6c996ef1"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=6c996ef1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFooter,VImg,VRow,VSpacer})
